<div class="select-label" [ngClass]="generalStatus">
    {{resourceStateCurrentStatus| translate}}
</div>